const DISABLE_CHECK_DOCUMENT_AUTHOR = "disable_check_document_author";
const MEASUREMENT_REPORT_URL = "measurement_report_url";
const HIDE_IKP_HEALTH_GROUP = "hide_ikp_healh_group";
const ALLOW_EDIT_DIAGNOSIS = "allow_edit_diagnosis";

export const FLAGS = Object.freeze({
  DISABLE_CHECK_DOCUMENT_AUTHOR,
  MEASUREMENT_REPORT_URL,
  HIDE_IKP_HEALTH_GROUP,
  ALLOW_EDIT_DIAGNOSIS,
});
